import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, RawActions, IEventFilter } from '@adage/ace-calendar';

import CalendarModeView from '../views/calendar-mode';

import { IWACEvent, InputOption, ICalendarReduxState } from '../classes';
import { changeToGrid, changeToList } from "../redux/actions/calendar-mode-actions";

interface StateToProps {
    isGrid: boolean;
}

interface CheckboxDispatchProps {
    setToGrid: () => any;
    setToList: () => any;
}

type CalendarModeProps = StateToProps & CheckboxDispatchProps;

interface CheckboxState {
}

class CalendarMode extends React.Component<CalendarModeProps, CheckboxState> {
    constructor(props: CalendarModeProps) {
        super(props);
    }

    onListEventClick(evt: React.MouseEvent<HTMLDivElement>) {
        this.props.setToList();
    }

    onGridEventClick(evt: React.MouseEvent<HTMLDivElement>) {
        this.props.setToGrid();
    }

    render(): JSX.Element {
        return (
            <div className="cal-nav-mode">
                <CalendarModeView xlinkHref="#calendar-list-view" text="List" onClick={this.onListEventClick.bind(this)} isSelected={!this.props.isGrid} />
                <CalendarModeView xlinkHref="#calendar-grid-view" text="Grid" onClick={this.onGridEventClick.bind(this)} isSelected={this.props.isGrid} />
            </div>
        )
    }
}

function comparison(property: string, expected: boolean) {
    return function (event: IWACEvent) {
        return true;
    }
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: CalendarModeProps) {
    return {
        setToGrid: () => dispatch(changeToGrid()),
        setToList: () => dispatch(changeToList())
    }
}

function mapStateToProps(state: ICalendarReduxState) {
    return {
        isGrid: state.calendarModeModel.isGrid
    }
}

export default connect<StateToProps, CheckboxDispatchProps>(mapStateToProps, mapDispatchToProps)(CalendarMode);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/calendar-mode.tsx